import React, { MouseEventHandler } from "react";

import { IconName } from "../../../styles/icons/icons";
import { ButtonTone } from "../../controls/Button/types";
import { Center } from "../../layout";
import ActionButton from "./components/ActionButton";
import DisplayIcon from "./components/DisplayIcon";
import InnerCircle from "./components/InnerCircle";
import LoadingPlaceholder from "./components/LoadingPlaceholder";
import OuterCircle from "./components/OuterCircle";
import {
  AvatarFormat,
  AvatarSize,
  avatarSizeToStylesMap,
  AvatarState
} from "./consts";

type Props = {
  size?: AvatarSize;
  state?: AvatarState;
  src?: string;
  avatarName?: string;
  format?: AvatarFormat;
  actionButtonTone?: ButtonTone;
  iconAccessibilityLabel?: string | null;
  iconName?: IconName;
  actionButtonOnClick?: MouseEventHandler;
};
export default function Avatar({
  size = "medium",
  state = "default",
  src,
  avatarName,
  format = "avatarOnly",
  iconName = "transfer",
  actionButtonTone = "primary",
  iconAccessibilityLabel = null,
  actionButtonOnClick = () => {}
}: Props) {
  const { imageSize } = avatarSizeToStylesMap[size];

  return (
    <OuterCircle avatarState={state} avatarSize={size}>
      <InnerCircle avatarState={state} avatarSize={size}>
        <Center>
          {src ? (
            <object
              data={src}
              style={{
                maxHeight: imageSize,
                maxWidth: imageSize,
                pointerEvents: "none"
              }}
            >
              {avatarName}
            </object>
          ) : (
            <LoadingPlaceholder size={size} />
          )}
        </Center>

        {format === "withButton" && (
          <ActionButton
            tone={actionButtonTone}
            iconName={iconName}
            avatarSize={size}
            accessibilityLabel={iconAccessibilityLabel}
            onClick={actionButtonOnClick}
          />
        )}
        {format === "withIcon" && (
          <DisplayIcon
            iconName={iconName}
            avatarSize={size}
            accessibilityLabel={iconAccessibilityLabel}
          />
        )}
      </InnerCircle>
    </OuterCircle>
  );
}
